import React, { useState, useEffect } from 'react';
import {
  useSearchParams, useLocation,
} from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai';
import './MonsterWalkPassword.css';
import '../../index.css';
import { gaEvents } from '../../util/events';
import { MONSTERWALK_PROD_TITLE_ID, MONSTERWALK_DEV_TITLE_ID } from '../../Constants';

function MonsterWalkPassword() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmedPassword, setConfirmedPassword] = useState('');
  const [queryParameters] = useSearchParams();
  const [isValid, setIsValid] = useState(false);
  const [hasLetter, setHasLetter] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [isProd, setIsProd] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const [confirmPasswordType, setConfirmPasswordType] = useState('password');
  const [passwordResetToken, setPasswordResetToken] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    // Check if we're on staging domain
    const hostname = window.location.hostname;
    const isStaging = hostname.includes('staging.monsterwalk');

    // Check prod parameter first
    const prodParam = queryParameters.get('prod');

    if (prodParam === 'true' && !isStaging) {
      setIsProd(true);
    } else if (prodParam === 'false') {
      setIsProd(false);
    } else if (!isStaging && hostname.includes('monsterwalk.talofagames.com')) {
      // Default to prod only if no prod parameter specified
      setIsProd(true);
    }
    if (!queryParameters.get('token')) {
      toast.error(
        'No reset token - please use the link in the Monster Walk App',
        {
          position: toast.POSITION.BOTTOM_RIGHT,
        },
      );
    } else {
      setPasswordResetToken(queryParameters.get('token'));
    }
  }, []);

  function resetPassword() {
    const PROD_RESET_LINK = 'https://gatekeeper-production-westus.talofagames.net/api/v1/account/ResetPassword';
    const NONPROD_RESET_LINK = 'https://gatekeeper-nonprod-westus.talofagames.net/api/v1/account/ResetPassword';
    const MONSTERWALK_TITLE_ID = isProd ? MONSTERWALK_PROD_TITLE_ID : MONSTERWALK_DEV_TITLE_ID;
    const RESET_LINK = isProd ? PROD_RESET_LINK : NONPROD_RESET_LINK;

    axios
      .post(
        RESET_LINK,
        {
          PasswordResetToken: passwordResetToken,
          NewPassword: password,
          TitleId: MONSTERWALK_TITLE_ID,
        },
      ).then((response) => {
        if (response.status === 200) {
          setIsSuccess(true);
        }
        gaEvents.resetPasswordSuccess();
      }).catch((err) => {
        toast.error(
          'Error updating - try reclicking the link in Monster Walk',
          {
            position: toast.POSITION.BOTTOM_RIGHT,
          },
        );
        gaEvents.resetPasswordError();
      });
  }

  function updatePassword(password) {
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);

    setHasLetter(hasLetter);
    setHasNumber(hasNumber);
    setPassword(password);
    if (confirmedPassword === password && hasLetter && hasNumber && password.length >= 7) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }

  function updateConfirmPassword(confirmedPassword) {
    setConfirmedPassword(confirmedPassword);
    if (confirmedPassword === password && hasLetter && hasNumber && password.length >= 7) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }

  function updatePasswordType(type) {
    setPasswordType(type);
  }

  function updateConfirmPasswordType(type) {
    setConfirmPasswordType(type);
  }

  const eyeIcon = passwordType === 'password' ? <AiFillEye onClick={() => updatePasswordType('text')} className="eye-icon" /> : <AiFillEyeInvisible onClick={() => updatePasswordType('password')} className="eye-icon" />;
  const confirmEyeIcon = confirmPasswordType === 'password' ? <AiFillEye onClick={() => updateConfirmPasswordType('text')} className="eye-icon" /> : <AiFillEyeInvisible onClick={() => updateConfirmPasswordType('password')} className="eye-icon" />;

  // if the dont have it - give an error message saying missing token
  return (
    <div className="password-container reset-container monsterwalk-reset">
      <img className="logo_mobile" src="./../monsterwalk-logo.png" />
      {!isSuccess
      && (
      <>
        <h1 className="password-header">Create New Password</h1>
        <div className="password">
          <div className="password-input-container">
            <input
              type={passwordType}
              name="email"
              placeholder="Your New Password"
              value={password}
              onChange={(e) => updatePassword(e.target.value)}
              className="form-control input-md password-input"
            />
            {/* {eyeIcon} */}
            {/* <AiFillEyeInvisible style={{ color: 'white' }} /> */}
          </div>
          <div className="password-input-container">
            <input
              type={confirmPasswordType}
              name="email"
              placeholder="Confirm New Password"
              value={confirmedPassword}
              onChange={(e) => updateConfirmPassword(e.target.value)}
              className="form-control input-md password-input"
            />
            {/* {confirmEyeIcon} */}
            {/* <AiFillEyeInvisible style={{ color: 'white' }} /> */}
          </div>
        </div>
        <div className="password-requirements">
          <h3 className={hasLetter ? 'passed-requirement' : 'failed-requirement'}>At least 1 letter (A-Z or a-z)</h3>
          <h3 className={hasNumber ? 'passed-requirement' : 'failed-requirement'}>At least 1 number (0-9))</h3>
          <h3 className={password.length >= 7 ? 'passed-requirement' : 'failed-requirement'}>At least 7 characters long</h3>
          <h3 className={password.length > 0 && password === confirmedPassword ? 'passed-requirement' : 'failed-requirement'}>Passwords must match</h3>
        </div>
        <button
          onClick={resetPassword}
          disabled={!isValid}
          className={isValid ? 'button password-reset' : 'button password-rest disabled'}
        >
          Submit
        </button>
      </>
      )}
      {isSuccess
              && (
              <>
                <h1 className="password-header">Success!</h1>
                <h2> If you don't see the password reset email, check your spam folder</h2>
              </>
              )}

    </div>

  );
}

export default MonsterWalkPassword;